'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _MyPlaylistItem = require('containers/MyPlaylists/components/MyPlaylistItem');

var _MyPlaylistItem2 = _interopRequireDefault(_MyPlaylistItem);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _SelectableList2 = require('components/SelectableList/SelectableList');

var _SelectableList3 = _interopRequireDefault(_SelectableList2);

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistsList.scss');

var MyPlaylistsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    checkedPlaylists: state.myPlaylists.checkedPlaylists
  };
}, (0, _extends3.default)({}, myPlaylistsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_SelectableList) {
  (0, _inherits3.default)(MyPlaylistsList, _SelectableList);

  function MyPlaylistsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, MyPlaylistsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyPlaylistsList.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsList)).call.apply(_ref, [this].concat(args)));

    _this.selectableConfig = (0, _extends3.default)({}, _this.selectableConfig, {
      idField: 'guid',
      propsField: 'playlists',
      updateFn: _this.props.updateCheckedPlaylists,
      checkedItemsPropsField: 'checkedPlaylists'
    });
    return _this;
  }

  (0, _createClass3.default)(MyPlaylistsList, [{
    key: 'onRowClick',
    value: function onRowClick(playlist) {
      this.toggleItemChecked(playlist.guid);
    }
  }, {
    key: 'onSelectionChange',
    value: function onSelectionChange(checkedSongs) {
      this.props.onSelect(checkedSongs);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          playlists = _props.playlists,
          loading = _props.loading,
          clickable = _props.clickable,
          selectable = _props.selectable,
          checkedPlaylists = _props.checkedPlaylists,
          withOptions = _props.withOptions,
          withIndex = _props.withIndex,
          className = _props.className,
          id = _props.id;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.list, className), id: id },
        playlists.map(function (playlist, index) {
          return _react2.default.createElement(_MyPlaylistItem2.default, {
            selectable: selectable,
            clickable: clickable,
            key: playlist.guid,
            playlist: playlist,
            onClick: _this2.onRowClick,
            checked: checkedPlaylists[playlist.guid],
            withOptions: withOptions,
            withIndex: withIndex,
            index: index + 1
          });
        }),
        loading && _react2.default.createElement(_Loader2.default, { alignCenter: true })
      );
    }
  }]);
  return MyPlaylistsList;
}(_SelectableList3.default), _class3.propTypes = {
  checkedPlaylists: _propTypes2.default.object,
  className: _propTypes2.default.string,
  clickable: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  playlists: _propTypes2.default.array,
  selectable: _propTypes2.default.bool,
  updateCheckedPlaylists: _propTypes2.default.func,
  withIndex: _propTypes2.default.bool,
  withOptions: _propTypes2.default.bool
}, _class3.defaultProps = {
  checkedPlaylists: {},
  onSelect: _noop3.default,
  playlists: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onRowClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRowClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSelectionChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectionChange'), _class2.prototype)), _class2)) || _class);
exports.default = MyPlaylistsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/components/MyPlaylistsList.js
// module id = 864
// module chunks = 1